import request from '../utils/request'

export default {
  // 获取所有场次
  findAll(params) {
    return request.get('/api/activity', { params })
  },
  
  // 根据ID获取场次
  findById(id) {
    return request.get(`/api/activity/${id}`)
  },
  
  // 添加场次
  add(activity) {
    return request.post('/api/activity', activity)
  },
  
  // 更新场次
  update(id, activity) {
    return request.put(`/api/activity/${id}`, activity)
  },

  // 更新状态
  updateStatus(id, status) {
    return request.put(`/api/activity/${id}/status`, { status })
  },
  
  // 删除场次
  delete(id) {
    return request.delete(`/api/activity/${id}`)
  },
  
  // 批量删除
  deleteBatch(ids) {
    return request.delete('/api/activity/batch', { data: ids })
  },

  // 分配设备
  assignTargets(activityId, targetIds) {
    return request.post(`/api/activity/${activityId}/targets`, targetIds)
  },

}